<template>
  <Plan :path="'/continueEdu'"></Plan>
</template>

<script>
  import Plan from '@/page/modules/plan/detail'
  export default {
    components: { Plan },
    mounted () {
    },
    data () {
      return {
      }
    }
  }
</script>

<style scoped>
  .online_bg { margin-top: 0 }
</style>



// WEBPACK FOOTER //
// src/page/continueEdu/plan/detail.vue